import {memo} from "react";
import {Tooltip} from "antd";
import {ceil} from "lodash";
import {numberFormat} from "~/utils";
import FontAwesomeIcon from "~/components/FontAwesome";

/**
 * Hàng thẻ KPI tổng quan toàn công ty cho Dashboard CEO.
 * Dữ liệu lấy từ dashboardApi.ceoOverview() và truyền vào qua props `data`.
 */
function StatCard({icon, label, value, sub, gradient}) {
	return (
		<div style={{
			borderRadius: 16, background: '#fff', padding: '16px 18px',
			boxShadow: '0 2px 12px rgba(0,0,0,0.06)', height: '100%',
			display: 'flex', alignItems: 'center', gap: 14,
		}}>
			<div style={{
				width: 48, height: 48, borderRadius: 12, flexShrink: 0,
				background: gradient, color: '#fff',
				display: 'flex', alignItems: 'center', justifyContent: 'center',
			}}>
				<FontAwesomeIcon icon={icon} style={{color: '#fff', fontSize: 22}} />
			</div>
			<div style={{minWidth: 0}}>
				<p style={{fontSize: 12, color: '#64748b', margin: 0}}>{label}</p>
				<p style={{fontSize: 20, fontWeight: 700, color: '#1e293b', margin: '2px 0 0', lineHeight: 1.1}}>{value}</p>
				{sub && <p style={{fontSize: 11, color: '#94a3b8', margin: '2px 0 0'}}>{sub}</p>}
			</div>
		</div>
	);
}

function CeoKpiCards({data}) {

	const revenue    = data?.revenue || {all: 0, plus: 0, commit: 0};
	const customer   = data?.customer || {all: 0, confirm: 0};
	const percent    = data?.commitDone ?? (revenue.commit > 0 ? ceil(revenue.all / revenue.commit * 100) : 0);

	const cards = [
		{
			icon: 'fa-light fa-sack-dollar',
			label: 'Doanh thu',
			value: numberFormat(revenue.all),
			sub: `Tính lương: ${numberFormat(revenue.plus)}`,
			gradient: 'linear-gradient(135deg, #0369a1 0%, #0284c7 60%, #38bdf8 100%)',
		},
		{
			icon: 'fa-light fa-bullseye-arrow',
			label: 'Đạt cam kết',
			value: `${percent}%`,
			sub: `Cam kết: ${numberFormat(revenue.commit)}`,
			gradient: 'linear-gradient(135deg, #6366f1 0%, #818cf8 60%, #a5b4fc 100%)',
		},
		{
			icon: 'fa-light fa-file-signature',
			label: 'Hợp đồng mới',
			value: numberFormat(data?.contractNew || 0),
			sub: 'Đã ký trong kỳ',
			gradient: 'linear-gradient(135deg, #be123c 0%, #e11d48 60%, #fb7185 100%)',
		},
		{
			icon: 'fa-light fa-user-plus',
			label: 'Khách hàng mới',
			value: numberFormat(customer.confirm),
			sub: `Tất cả: ${numberFormat(customer.all)}`,
			gradient: 'linear-gradient(135deg, #b45309 0%, #e47d0a 60%, #f59e0b 100%)',
		},
		{
			icon: 'fa-light fa-users',
			label: 'Nhân sự',
			value: numberFormat(data?.headcount || 0),
			sub: 'Đang hoạt động',
			gradient: 'linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%)',
		},
	];

	return (
		<div style={{display: 'flex', flexWrap: 'wrap', gap: 16}}>
			{cards.map((card, index) => (
				<div key={`ceo-kpi-${index}`} style={{flex: '1 1 180px', minWidth: 180}}>
					<Tooltip title={card.sub}>
						<div style={{height: '100%'}}><StatCard {...card} /></div>
					</Tooltip>
				</div>
			))}
		</div>
	);
}

export default memo(CeoKpiCards);
